import React from 'react';
import { TWSubscriptionPlanCardType } from '.';
import classNames from 'classnames';
import { getPriceString } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Renders either "x$25x $20" (xx = strikeout) or just "$25"
export var PriceComponent = function PriceComponent(_ref) {
  var _plan$invoicePreview;

  var plan = _ref.plan,
      subscribedToService = _ref.subscribedToService,
      interval = _ref.interval,
      type = _ref.type,
      canShowDiscount = _ref.canShowDiscount;

  // we expect an InvoicePreview with a discount to have more than one line, and at least one of the lines to have a negative amount (the discount)
  if (canShowDiscount && !subscribedToService && ((_plan$invoicePreview = plan.invoicePreview) === null || _plan$invoicePreview === void 0 ? void 0 : _plan$invoicePreview.lines.length) > 1 && plan.invoicePreview.lines.reduce(function (acc, next) {
    return acc || next.amount < 0;
  }, false)) {
    return /*#__PURE__*/_jsxs("div", {
      className: "flex items-center justify-center",
      children: [/*#__PURE__*/_jsx("span", {
        className: "mr-2 line-through fw-500 text-gray-300 text-base",
        children: getPriceString(plan.invoicePreview.lines[0].amount, plan.currency)
      }), /*#__PURE__*/_jsx("span", {
        className: "fw-700 text-gray-900 text-2xl",
        children: getPriceString(plan.invoicePreview.total, plan.currency)
      }), /*#__PURE__*/_jsx("span", {
        className: "ml-1",
        children: "/".concat(interval)
      })]
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    className: classNames('flex', {
      'items-center justify-center': type === TWSubscriptionPlanCardType.FULL_WIDTH,
      hidden: plan.waitlist
    }),
    children: [/*#__PURE__*/_jsx("span", {
      className: "text-4.5xl font-extrabold text-gray-900",
      children: getPriceString(plan.price_cents, plan.currency)
    }), /*#__PURE__*/_jsx("div", {
      className: "flex",
      children: /*#__PURE__*/_jsx("span", {
        className: classNames('ml-1 text-lg text-gray-900', {
          'self-center': type === TWSubscriptionPlanCardType.FULL_WIDTH,
          'self-end pb-0.5': type === TWSubscriptionPlanCardType.SKINNY
        }),
        children: "/".concat(interval)
      })
    })]
  });
};
// Renders "20% of for 3 months" in yellow pill
export var ReferralDiscountPill = function ReferralDiscountPill(_ref2) {
  var plan = _ref2.plan;
  if (!plan.invoicePreview) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "rounded-2xl text-yellow-700 bg-yellow-100 fw-500 px-4 py-1",
    children: plan.invoicePreview.lines.filter(function (l) {
      return l.amount < 0;
    })[0].description
  });
};